// extracted by mini-css-extract-plugin
export default {"header":"ExplanationBullets--header--defb00","container":"ExplanationBullets--container--f9e266"};